import React from 'react';
import VerificationNeeded from '../../../stories/components/OnboardingNew/PopUp/VerificationNeeded/VerificationNeeded';

const Manual = () => {
    return(
        <VerificationNeeded />
    )
}

export default Manual;